/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-group-search[_ngcontent-%COMP%]{width:400px;margin-right:10px}#showRemovedCheckBox[_ngcontent-%COMP%]{margin-left:10px}#show_removed_text_span[_ngcontent-%COMP%]{padding-left:2px}.organization[_ngcontent-%COMP%]{display:inline-block;width:100%;padding:5px 10px 5px 5px;font-size:large;border-left:4px solid #fff}.organization.viewable[_ngcontent-%COMP%]{color:#2a6ebb;cursor:pointer}.organization.viewable[_ngcontent-%COMP%]:hover{border-left:4px solid #2a6ebb}"];
export { styles as styles };
